import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GlobalModal } from "../../components/authModals";
import getUser from "../../api/user";
import { setUser } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import GameHeader from "./GameHeader";
import { GameDetailsProvider } from "./GameDetailsContext";

const GameLayout = () => {
  const storedLang = localStorage.getItem("i18nextLng") || "en";
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    // Read token inside useEffect to get the latest value
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (!token || token === "undefined" || token === "null" || token.trim() === "") {
      navigate("/");
    }
  }, [navigate]);

  const getUserData = async () => {
    try {
      const user = await getUser();
      dispatch(setUser(user as any));
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  useEffect(() => {
    i18n.changeLanguage(storedLang);
    document.documentElement.dir = storedLang === "ar" ? "rtl" : "ltr";
  }, [i18n, storedLang]);

  return (
    <>
      <GlobalModal />
      {/* <main className="flex h-screen bg-bg-secondary overflow-hidden">
        <section className="flex-1 flex flex-col h-full overflow-hidden">
          <div className="overflow-auto bg-[#F7F7F7] h-full sidebar-scroll"> */}
            <GameDetailsProvider>
              <GameHeader />
              <Outlet />
            </GameDetailsProvider>
          {/* </div>
        </section>
      </main> */}
      {/* {!isLoading && isSuccess ? (
        <main className="flex h-screen bg-bg-secondary overflow-hidden">
        <section className="flex-1 flex flex-col h-full overflow-hidden">
          <div className="overflow-auto bg-[#F7F7F7] h-full sidebar-scroll">
            <MainHeader />
            <Outlet />
          </div>
        </section>
      </main>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <Loader />
        </div>
      )} */}
    </>
  );
};

export default GameLayout;
